import React from 'react';

/**
 * Browser start screen
 *
 * Allows for entering a project title and getting started
 *
 * @author John Noel <john.noel@joipolloi.com>
 * @package Minifigs
 */
const Start = () => {
    return (
        <div className="start">
            <div className="start-inner">
                <h2>Start by exploring the different options e.g. hats and hair!</h2>
            </div>
        </div>
    );
};

export default Start;
